import { ConfigProvider } from "antd";
import { FC, ReactNode } from "react";
import { OverrideToken } from "antd/es/theme/interface";
import { GlobalStyle } from "../styles/global.style";

interface IProps {
  children: ReactNode;
}

const ConfigProviders: FC<IProps> = ({ children }) => {
  const darkThemeComponents: OverrideToken = {
    Button: {
      borderRadius: 8,
      colorBgBase: "#F5F5F5",
      fontSize: 14,
      controlHeight: 42,
      paddingContentHorizontal: 24,
      colorBorder: "#F5F5F5",
      colorBgContainer: "#F5F5F5",
      colorText: "#8E8E8E",
      colorBgContainerDisabled: "#93C8FF",
      colorTextDisabled: "#BDDDFF",
    },
    Input: {
      colorTextPlaceholder: "#878787",
      colorBgContainerDisabled: "#F3F4F5",
      colorTextDisabled: "#001377",
    },

    Select: {
      colorTextPlaceholder: "#878787",
      colorBgContainerDisabled: "#F3F4F5",
      colorTextDisabled: "#001377",
    },
    DatePicker: {
      colorTextPlaceholder: "#878787",
      colorBgContainerDisabled: "#F3F4F5",
      colorTextDisabled: "#001377",
    },
    // Drawer: {
    //   colorBgLayout: "#282B34",
    //   colorBgContainer: "#282B34",
    //   colorBgElevated: "#282B34",
    //   colorText: "#D3D3D3",
    //   colorTextBase: "#D3D3D3",
    // },
    // Menu: {
    //   colorItemBgActive: "#26A69A",
    //   colorText: "#D3D3D3",
    //   colorItemBgSelected: "#24E3BF1A",
    //   radiusItem: 2,
    //   colorItemTextSelected: "#25E3BF",
    //   colorItemText: "#D3D3D3",
    //   colorSubItemBg: "transparent",
    // },
    Modal: {
      colorBgMask: "rgba(44, 115, 252, 0.40)",
      titleColor: "#001377",
      titleFontSize: 16,
    },
    // Table: {
    //   colorBgContainer: "transparent",
    //   colorText: "#949494",
    //   colorTextHeading: "#D3D3D3",
    // },
    // Radio: {
    //   colorBgContainer: "#56575B",
    //   colorBorder: "transparent",
    // },
    // DatePicker: {
    //   colorBgLayout: "#282B34",
    //   colorBgContainer: "#282B34",
    //   colorBgElevated: "#282B34",
    // },
  };

  const antdTheme = {
    components: darkThemeComponents,
  };

  return (
    <ConfigProvider theme={antdTheme}>
      <GlobalStyle />
      {children}
    </ConfigProvider>
  );
};

export default ConfigProviders;
